import { render, staticRenderFns } from "./ClientesTerrestresPage.vue?vue&type=template&id=98b67ebe"
import script from "./ClientesTerrestresPage.vue?vue&type=script&lang=js"
export * from "./ClientesTerrestresPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports